import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(private authService: AuthService) {}
  /**
   * Decides if a route can be activated depending on the user's attributes.
   * If all guards return `true`, navigation will continue. If any guard returns `false`,
   * navigation will be cancelled.
   *
   * @return An observable indicating if the route is able to be activated.
   */
  canActivate(): Promise<boolean> | boolean {
    const loginState = this.authService.loginState;
    if (!loginState) {
      // user is not logged in, redirect to login
      this.authService.federatedOktaSignIn();
    }
    return this.authService.fetchUserDetails();
  }
}
